import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'moment/locale/es';
import IconChat from '../../Icons/IconChat';

type Props = {
  onChange: (value: string) => void;
  months: string[];
  tipo: string;
  id: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PuntosFilter: FC<Props> = ({ onChange, months, tipo, id }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');

  const handleChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const selectedId = e.currentTarget.value;
    setValue(String(selectedId));
    onChange(String(selectedId));
  };
  return (
    <>
      <div className="form-group select-wrapper">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="control-label">
          {tipo === 'inicio' ? t('travel.fromDate') : t('travel.toDate')}
        </label>
        <div className="form-control-block">
          <select
            id={id}
            className="form-control"
            value={value}
            onChange={(e) => handleChange(e)}
          >
            {months &&
              months.map((y) => (
                <option key={y.split(',')[0]} value={y.split(',')[0]}>
                  {y.split(',')[1]}
                </option>
              ))}
          </select>
          <div className="icon icon-small">
            <IconChat />
          </div>
        </div>
      </div>
    </>
  );
};

export default PuntosFilter;
